import { ClientType } from '../apollo'
import { MutationResult, types } from '../types'

import { updateOneProfile_Channel } from '@dinosband/bv-main-schema/dist/client-gql'
import { Attachment } from '@dinosband/bv-attachment'

export async function updatePropsOfProfile_Channel (client: ClientType, profile_ChannelId: number, props: types.Profile_ChannelProps): Promise<types.Profile_Channel | undefined> {
  try {
    const res = await client.mutate({
      mutation: updateOneProfile_Channel,
      variables: {
        where: {
          id: profile_ChannelId,
        },
        data: {
          props: {
            set: JSON.stringify(props),
          },
        },
      } as types.MutationUpdateOneProfile_ChannelArgs,
    }) as MutationResult
    return res.data.updateOneProfile_Channel
  } catch (e) {
  }
}

export async function updateUserInfoOfProfile_Channel (client: ClientType, profile_ChannelId: number, userInfo: Record<string, unknown>, userAttachments?: Attachment[] | null): Promise<types.Profile_Channel | undefined> {
  const data: types.Profile_ChannelUpdateInput = {
    userInfo,
  }
  if (userAttachments !== null) {
    data.userAttachments = userAttachments
  }
  try {
    const res = await client.mutate({
      mutation: updateOneProfile_Channel,
      variables: {
        where: {
          id: profile_ChannelId,
        },
        data,
      } as types.MutationUpdateOneProfile_ChannelArgs,
    }) as MutationResult
    return res.data.updateOneProfile_Channel
  } catch (e) {
  }
}

export async function updateNamespaceOfProfile_Channel (client: ClientType, profile_ChannelId: number, namespace: string): Promise<types.Profile_Channel | undefined> {
  const data: types.Profile_ChannelUpdateInput = {
    namespace: { set: namespace },
  }
  try {
    const res = await client.mutate({
      mutation: updateOneProfile_Channel,
      variables: {
        where: {
          id: profile_ChannelId,
        },
        data,
      } as types.MutationUpdateOneProfile_ChannelArgs,
    }) as MutationResult
    return res.data.updateOneProfile_Channel
  } catch (e) {
  }
}

export async function updateAgreePrivacyAtOfProfile_Channel (client: ClientType, profile_ChannelId: number, agreePrivacyAt: Date): Promise<types.Profile_Channel | undefined> {
  const data: types.Profile_ChannelUpdateInput = {
    agreePrivacyAt: { set: agreePrivacyAt },
  }
  try {
    const res = await client.mutate({
      mutation: updateOneProfile_Channel,
      variables: {
        where: {
          id: profile_ChannelId,
        },
        data,
      } as types.MutationUpdateOneProfile_ChannelArgs,
    }) as MutationResult
    return res.data.updateOneProfile_Channel
  } catch (e) {
  }
}

export async function updateCurrentExpertIdOfProfile_Channel (client: ClientType, profile_ChannelId: number, currentExpertId: number): Promise<types.Profile_Channel | undefined> {
  try {
    const res = await client.mutate({
      mutation: updateOneProfile_Channel,
      variables: {
        where: {
          id: profile_ChannelId,
        },
        data: {
          currentExpertId: { set: currentExpertId },
        },
      } as types.MutationUpdateOneProfile_ChannelArgs,
    }) as MutationResult
    return res.data.updateOneProfile_Channel
  } catch (e) {
  }
}

export async function updateNoDefaultExpertOfProfile_Channel (client: ClientType, profile_ChannelId: number, noDefault: boolean): Promise<types.Profile_Channel | undefined> {
  try {
    const res = await client.mutate({
      mutation: updateOneProfile_Channel,
      variables: {
        where: {
          id: profile_ChannelId,
        },
        data: {
          noDefaultExpert: { set: noDefault },
        },
      } as types.MutationUpdateOneProfile_ChannelArgs,
    }) as MutationResult
    return res.data.updateOneProfile_Channel
  } catch (e) {
  }
}

export async function updateProfile_Channel (client: ClientType, profile_ChannelId: number, data: types.Profile_ChannelUpdateInput): Promise<types.Profile_Channel | undefined> {
  try {
    const res = await client.mutate({
      mutation: updateOneProfile_Channel,
      variables: {
        where: {
          id: profile_ChannelId,
        },
        data,
      } as types.MutationUpdateOneProfile_ChannelArgs,
    }) as MutationResult
    return res.data.updateOneProfile_Channel
  } catch (e) {
  }
}
